import { render, staticRenderFns } from "./onadvCard.vue?vue&type=template&id=b67eedba&"
import script from "./onadvCard.vue?vue&type=script&lang=js&"
export * from "./onadvCard.vue?vue&type=script&lang=js&"
import style0 from "./onadvCard.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports